import DynamicTabs from './DynamicTabs'

export default DynamicTabs
